import React, { useRef, useState } from "react";
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';

import servicioArchivos from '../../servicio/ServicioArchivos';
import servicioFormatos from '../../servicio/ServicioFormatos';
import servicioDocumentoIDSE from '../../servicio/ServicioFormarCuerpoDocumentoIdse';
import { isIE } from '../../servicio/ServicioCodificacionArchivos';
import servicioHttp from '../../servicio/ServicioHttp';
import servicioObjetos from '../../servicio/ServicioObjetos';

import { AlertaFechaMovimientos } from '../enviomovimientos/AlertaFechaMovimientos';

export const BotonesAcciones2023 = (props) => {

    let { movimientosSeleccionados, setMovimientosSeleccionados, setMovimiento,
        movimientosCapturados, setMovimientosCapturados } = props;

    const [movimientosResumen, setMovimientosResumen] = useState([]);
    const [movimientosEnviados, setMovimientosEnviados] = useState([]);

    let growl = useRef(null);

    const eliminar = () => {
        setMovimientosCapturados(elementos => {
            for (let i = 0; i < movimientosSeleccionados.length; i++) {
                let elemento = movimientosSeleccionados[i];
                const indice = elementos.indexOf(elemento);
                elementos.splice(indice, 1);

                setMovimientosSeleccionados(movsCapturados => {
                    const indiceCapts = movsCapturados.indexOf(elemento);
                    movsCapturados.splice(indiceCapts, 1);
                    return movsCapturados;
                });
            }
            return elementos;
        });
    }

    const editar = () => {
        let movimiento = JSON.parse(JSON.stringify(movimientosSeleccionados[0]));
        let timestamp = Date.parse(movimiento.fechaMovimiento);
        let dateObject = new Date(timestamp);
        movimiento.fechaMovimiento = dateObject;
        setMovimiento(movimiento);
    }

    const enviar = () => {
        let formData = new FormData();
        let losIdsEnviar = [];
        for (var i = 0; i < movimientosSeleccionados.length; i++) {
            let objetoSelecionado = movimientosSeleccionados[i];
            losIdsEnviar.push(objetoSelecionado.elId);
            let fechaParseadaNombreArchivo = servicioFormatos.formatearFechaStringArchivoIdse(objetoSelecionado.fechaMovimiento);
            let renglon = servicioDocumentoIDSE.generarCuerpo2023(objetoSelecionado);
            let registroPatronal = objetoSelecionado.registroPatronal.split("-")[0].trim();
            let nombreArchivo = registroPatronal + "_" + objetoSelecionado.tcTrabajador.numeroSeguridadSocial + "_" + fechaParseadaNombreArchivo + ".txt";
            let file = null;

            if (isIE()) {
                file = new Blob([renglon], { type: "text/plain" });
                file['name'] = nombreArchivo;
                file['lastModifiedDate'] = Date.now();
                formData.append("recibos", file, nombreArchivo);
            } else {
                file = new File([renglon], nombreArchivo, { type: "text/plain" });
                formData.append("recibos", file);
            }
        }
        setMovimientosEnviados(losIdsEnviar);
        servicioHttp.consumirPostHttp("/movimientos/procesar.json", formData).then(response => {
            let listaResultados = servicioObjetos.esObjetoVacio(response.data.objeto) ? [] : response.data.objeto.archivoTxt;
            setMovimientosResumen(listaResultados);
        }).catch(error => {
            console.log("error:", error);
        });
    }

    const exportar = () => {
        let movimientosAExcel = [];
        for (let i = 0; i < movimientosSeleccionados.length; i++) {
            let elemento = movimientosSeleccionados[i];

            let registroPatronal = elemento.registroPatronal.split("-")[0].trim();
            let fechaMovimiento = servicioFormatos.formatearFechaStringArchivoIdse(elemento.fechaMovimiento);
            let movimientosCapturaManual = {
                registroPatronal: registroPatronal,
                tipoMovimiento: elemento.tipoMovimiento,
                fechaMovimiento: fechaMovimiento,
                tcTrabajador: elemento.tcTrabajador,
                curp: elemento.curp,
                umf: elemento.umf,
                claveTrabajador: elemento.claveTrabajador,
                tipoTrabajador: elemento.tipoTrabajador,
                salarioDiarioIntegrado: elemento.salarioDiarioIntegrado,
                tipoSalario: elemento.tipoSalario,
                jornadaReducida: elemento.jornadaReducida,
                causaBaja: elemento.causaBaja
            }
            movimientosAExcel.push(movimientosCapturaManual);
        }
        servicioArchivos.descargaArchivo("/documentos/captura_manual.json", movimientosAExcel);
    }


    const guardarMovimientos = () => {
        growl.current.clear();
        servicioHttp.consumirPostHttp("/movimientos/crear_movimientos.json", movimientosResumen).then((response) => {
            if (response.data.objeto.errores.length > 0) {
                for (let i = 0; i < response.data.objeto.errores.length; i++) {
                    let valor = response.data.objeto.errores[i];
                    growl.current.show({ severity: 'error', summary: 'Error', detail: valor, life: 9000 });
                }
            }

            if (response.data.objeto.exitos.length > 0) {
                for (let i = 0; i < response.data.objeto.exitos.length; i++) {
                    let valor = response.data.objeto.exitos[i];
                    growl.current.show({ severity: 'success', summary: 'Éxito', detail: valor, life: 9000 });
                }
            }
            setMovimientosResumen([]);
            setMovimientosSeleccionados([]);
            let nuevosMovimientosCapturados = [...movimientosCapturados];
            for (let i = 0; i < movimientosEnviados.length; i++) {
                let elId = movimientosEnviados[i];
                let elementoBuscar = servicioObjetos.obtenerObjetoDeArregloPorPropiedad(nuevosMovimientosCapturados, 'elId', elId);
                if (!servicioObjetos.esObjetoVacio(elementoBuscar)) {
                    servicioObjetos.eliminarObjetoMapa(nuevosMovimientosCapturados, elementoBuscar);
                }
            }
            setMovimientosCapturados(nuevosMovimientosCapturados);
        }).catch((error) => {
            console.log("ERROR => ", error);
        });
    }

    const cerrarEnvioModal = () => {
        setMovimientosResumen([]);
    }

    return (<div className="card">
        <Growl ref={growl} />
        <AlertaFechaMovimientos funcionGuardarMovimientos={guardarMovimientos}
            datos={movimientosResumen} setDatos={setMovimientosResumen}
            funcionCerrar={cerrarEnvioModal} />
        <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-3">
                <Button label="Eliminar" icon="pi-md-delete" onClick={eliminar}
                    disabled={movimientosSeleccionados.length === 0} />
            </div>
            <div className="p-col-12 p-md-3">
                <Button label="Editar" icon="pi-md-mode-edit" onClick={editar}
                    disabled={movimientosSeleccionados.length !== 1} />
            </div>
            <div className="p-col-12 p-md-3">
                <Button label="Enviar" icon="pi-md-send" onClick={enviar}
                    disabled={movimientosSeleccionados.length === 0} />
            </div>
            <div className="p-col-12 p-md-3">
                <Button label="Exportar" icon="pi-md-import-export" onClick={exportar}
                    disabled={movimientosSeleccionados.length === 0} />
            </div>
        </div>
    </div>);
}